import React, { memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { PropsType } from '@sport1/react-elements/Types'
import AssetImage from '../../Asset'
import colorPattern from '../../../..//DesignSystem/colors'
import { TestID } from '@/utils/PropTypesDefinitions'

/* eslint-disable @typescript-eslint/no-var-requires */
const FALLBACK_ICON = require('../../../../assets/defaultImage/player/Player.svg')

type FallbackProps = Pick<PropsType, 'width'> & TestID

const PlayerImageFallback = ({ width = '100%', testID }: FallbackProps): ReactElement => {
    return (
        <Grid
            testID="wrapper-fallback"
            noExpand
            height={width}
            width={width}
            backgroundColor={colorPattern.moon}
            center
        >
            <AssetImage imageUrl={FALLBACK_ICON} testID={testID} />
        </Grid>
    )
}

export default memo(PlayerImageFallback)
